import React, {Component, ReactNode} from 'react'
import {Stepper, Step, StepLabel, StepperProps} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'

interface Props extends Omit<StepperProps, 'children'> {
    steps: string[],
}

interface State {

}

class PPStepper extends Component<Props, State> {
    render(): ReactNode {
        const {
            steps,
            activeStep,
            ...rest
        } = this.props

        return <StyledStepper activeStep={activeStep} {...rest}>
            {steps.map((step, index) => (
                <Step
                    key={index}
                    completed={(activeStep && index < activeStep) || (steps.length - 1 === activeStep)}
                >
                    <StyledStepLabel>{step}</StyledStepLabel>
                </Step>
            ))}
        </StyledStepper>
    }
}

export default PPStepper

const StyledStepper = styled(Stepper)`
  && {
    padding: 10px;
    background-color: transparent;
  }
`

const StyledStepLabel = styled(StepLabel)`
  .MuiStepIcon-text {
    font-size: ${FontSize.Small};
    transform: translateY(-1px);
  }

  .MuiStepIcon-root {
    font-size: ${FontSize.Big};
    color: ${Colors.SecondaryActive};
  }

  && .Mui-active, && .Mui-completed {
    color: ${Colors.Primary};
  }

  && .MuiStepLabel-label {
    font-size: ${FontSize.Middle};
    color: ${Colors.Body};
    ${currentMedia.lessThan('sp')`
            font-size: ${FontSize.Small};
            font-weight: ${FontWeights.Bold};
            margin-top: 10px;
        `};
  }
`
